import { Space, Spin, Form, Button, Input, DatePicker } from 'antd';
import { useSelector, useDispatch } from 'react-redux'
import { requestUserInfoGeneral } from './store/store';
import { timestampToLocalDatestring } from './store/utils.js'
import { unix } from "moment"
import {
  setFirstName,
  setSecondName,
  setEmail,
  submitInfoToServer,
  setBirthdayDate,
  sendInfoToServer } from "./store/userinfo"

function GeneralForm() {
  const info = useSelector(state => state.userinfo.info)
  const needsServerUpdate = useSelector(state => state.userinfo.needsServerUpdate)
  const dispatch = useDispatch()

  const onBirthdayChange = (date, dateString) => {
    dispatch(setBirthdayDate(date.unix()))
  };

  const onSubmit = () => {
    sendInfoToServer(info)
    dispatch(submitInfoToServer())
  };

  return (
    // <div>
    //   Общие свойства пользователя: {JSON.stringify(userinfo.info)}
    // </div>
    <Form
    labelCol={{
      span: 4,
    }}
    wrapperCol={{
      span: 14,
    }}
    layout="horizontal"
  >
    <Form.Item label="Имя"><Input autoComplete="given-name" value={info.first_name} onChange={(e) => dispatch(setFirstName(e.target.value))}/></Form.Item>
    <Form.Item label="Фамилия"><Input autoComplete="family-name" value={info.second_name} onChange={(e) => dispatch(setSecondName(e.target.value))}/></Form.Item>
    <Form.Item label="e-mail"><Input autoComplete="email" value={info.email} onChange={(e) => dispatch(setEmail(e.target.value))}/></Form.Item>
    <Form.Item label="Дата рождения"><DatePicker defaultValue={unix(info.birthday)} onChange={onBirthdayChange} /></Form.Item>
    <Form.Item label="Дата регистрации">{timestampToLocalDatestring(info.created)}</Form.Item>
    <Form.Item>
        <Button type="primary" disabled={!needsServerUpdate} onClick={onSubmit}>Применить изменения</Button>
    </Form.Item>
  </Form>
  )
}

function SettingsGeneralTab() {

  const userinfo = useSelector(state => state.userinfo)

  if (!userinfo.info || !userinfo.info.first_name) {
    if (userinfo.infoIsLoading === false) {
      requestUserInfoGeneral()
    }

    return (
      <Space><Spin/>Загрузка...</Space>
    )
  }
  else {
    return (
      <GeneralForm />
    )
  }
}

export default SettingsGeneralTab